import { atom } from 'jotai';
import type { UploadFile } from 'antd';
import type { WorkHistoryPreview } from '../api/gStaffMutations';

export const gStaffFileListAtom = atom<UploadFile[]>([]);

/** S3 へアップロード済みのファイルを指すステージングキー。反映リクエストはこのキーで行う */
export const gStaffStagedKeyAtom = atom<string | null>(null);

/** 選択中ファイルのサーバー検証結果。未検証・ファイル未選択時は null */
export const gStaffPreviewAtom = atom<WorkHistoryPreview | null>(null);

/** 検証リクエスト送信中。送信中はファイル差し替えと反映を受け付けないこと */
export const gStaffValidatingAtom = atom(false);

/** 反映リクエスト送信中。送信中はファイル差し替えと再反映を受け付けないこと */
export const gStaffUploadingAtom = atom(false);
